import { createSlice } from "@reduxjs/toolkit"

export const userOtpSlice = createSlice({
	name: "otp",
	initialState: {
		otpMessage: "",
		errors: [],
	},

	reducers: {
		getOtpMessage: (state, action) => {
			state.otpMessage = action.payload
		},
		getOtpMessageSuccess: (state, action) => {
			state.otpMessage = action.payload
		},
		getResendOtpMessage: (state, action) => {
			console.log(action.payload, "reducer")
			state.users = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload

			// console.log(action.payload, "reducer")
		},
	},
})

// Action creators are generated for each case reducer function
export const {getOtpMessage, getOtpMessageSuccess, getErrors, getResendOtpMessage} = userOtpSlice.actions

export default userOtpSlice.reducer
